import script from "./DeveloperOverview.vue?vue&type=script&setup=true&lang=js"
export * from "./DeveloperOverview.vue?vue&type=script&setup=true&lang=js"

import "./DeveloperOverview.vue?vue&type=style&index=0&id=7bde1269&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7bde1269"]])

export default __exports__